export enum SortType {
    Asc = 0,
    Desc = 1
}

export interface SortCondition {
    sortField: string;
    sortType: SortType;
}

export const SortTypes = [
    { label: 'ååº', value: SortType.Asc },
    { label: 'éåº', value: SortType.Desc }
];
